export const courseGroupNames = {
  KickStart: 'Kick start',
  ProgrammingLanguage: 'Programming language',
  FundamentalProblemSolving: 'Fundamental problem solving',
  DataStructures: 'Data structures',
  Algorithms: 'Algorithms',
  InterviewPreparation: 'Interview preparation',
  FrontEndDevelopment: 'Frontend development',
  SoftwareTesting: 'Software testing',
  DataAnalysis: 'Data analysis',
  Basics: 'Basics',
  NumberSystem: 'Number system',
};
